module.exports = __webpack_public_path__ + "static/media/5cent.e3fe65fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupures/5cent.png
// module id = 923
// module chunks = 0